import { RootState } from "../../rootReducer";

export const selectIsLoading = (state: RootState) =>
  state.dataDestination.loading;
export const selectErrorMessage = (state: RootState) =>
  state.dataDestination.error;
export const dataDestinationResponse = (state: RootState) =>
  state.dataDestination.dataDestinationResponse;
